import React from 'react';
import { Typography } from '@mui/material';
import ExploreRoundedIcon from '@mui/icons-material/ExploreRounded';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import AlternateEmailRoundedIcon from '@mui/icons-material/AlternateEmailRounded';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

import TypoBlock from './TypoBlock';

import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';


const PrettyLink = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  color: '#283054',
  "&:hover": {
    color: "#2d3d81ff",
    textDecoration: 'underline'
  },
}));



export default function Coordonnees() {

  return (
    <TypoBlock id='Coordonnées'>
      <Grid
        container 
        direction="row"
        // justify="center"
        alignItems="stretch"
        // spacing={2}
      >
        <Grid item xs={12} sm={12}>
          <Typography variant='h1'>Coordonnées</Typography>
        </Grid>
        <Grid item xs={12} sm={6} sx={{fontSize:'1.3em'}}>
          <p>
            <ExploreRoundedIcon fontSize='large'/><br/>
            Marjolaine Benmoussa<br/>
            5 boulevard du Roi René<br/>
            13100 Aix-en-Provence
          </p>
        </Grid>
        <Grid item xs={12} sm={6} sx={{fontSize:'1.3em'}}>
          <p>
            <PhoneRoundedIcon fontSize='large'/><br/>
            <PrettyLink href='tel:0782389861'>07 82 38 98 61</PrettyLink>
          </p>
          <p>
            <AlternateEmailRoundedIcon fontSize='large'/><br/>
            <PrettyLink href='mailto:contact@mbgraphotherapeute.fr'>contact@mbgraphotherapeute.fr</PrettyLink>
          </p>
        </Grid>
        <Grid item xs={12} sm={12}>
          <p>
          <PrettyLink href='https://www.facebook.com/people/Marjolaine-Benmoussa-Graphothérapeute/100068888671212/' target='_blank' rel='noreferrer'><FacebookIcon fontSize='large'/></PrettyLink>
          <PrettyLink href='https://www.instagram.com/mbgrapho_aix/' target='_blank' rel='noreferrer'><InstagramIcon fontSize='large'/></PrettyLink>
          <PrettyLink href='https://fr.linkedin.com/in/marjolaine-benmoussa-b25458217' target='_blank' rel='noreferrer'><LinkedInIcon fontSize='large'/></PrettyLink>
          </p>
        </Grid>
      </Grid>
    </TypoBlock>
  );
}
